import React from 'react';
import Link from '@mui/material/Link';
import makeStyles from '@mui/styles/makeStyles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Title from './Title';
import { MoneyFormattedUtils } from 'core/libs/core-ui/utils/moneyFormatted';
import { DateFormattedUtils } from 'core/libs/core-ui/utils/dateTimeFormatted';

// Generate Order Data
// function createData(id, date, name, shipTo, paymentMethod, amount) {
//   return { id, date, name, shipTo, paymentMethod, amount };
// }

// const rows = [
//   createData(0, '16 Mar, 2019', 'Elvis Presley', 'Tupelo, MS', 'VISA ⠀•••• 3719', 312.44),
//   createData(1, '16 Mar, 2019', 'Paul McCartney', 'London, UK', 'VISA ⠀•••• 2574', 866.99),
//   createData(2, '16 Mar, 2019', 'Tom Scholz', 'Boston, MA', 'MC ⠀•••• 1253', 100.81),
//   createData(3, '16 Mar, 2019', 'Michael Jackson', 'Gary, IN', 'AMEX ⠀•••• 2000', 654.39),
//   createData(4, '15 Mar, 2019', 'Bruce Springsteen', 'Long Branch, NJ', 'VISA ⠀•••• 5919', 212.79),
// ];

function preventDefault(event) {
  event.preventDefault();
}

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
}));

export default function Orders({recentOrders, ...props}) {
  const classes = useStyles();
  const rows = recentOrders;
  return (
    <React.Fragment>
      <Title>Recent Bookings</Title>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Created</TableCell>
            <TableCell>Code</TableCell>
            <TableCell>Date</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Exp ID</TableCell>
            <TableCell>Status</TableCell>
            <TableCell align="right">Total Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell>{DateFormattedUtils(row.createdOn)}</TableCell>
              <TableCell>{row.code}</TableCell>
              <TableCell>{DateFormattedUtils(row.date)}</TableCell>
              <TableCell>{row.email}</TableCell>
              <TableCell>{row.experienceDetailId}</TableCell>
              <TableCell>{row.status}</TableCell>
              <TableCell align="right">{row.currency} { MoneyFormattedUtils(row.price)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className={classes.seeMore}>
        <Link color="primary" href="/booking" >
          See more bookings
        </Link>
      </div>
    </React.Fragment>
  );
}